import { isReadingPanePositionRight } from '../selectors/readingPanePosition';
import { shouldShowReadingPane } from '../selectors/shouldShowReadingPane';
import { shouldShowBizChatInReadingPane } from 'owa-copilot-chat-drawer-store';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Determines if BizChat should be docked in the reading pane based on current layout conditions.
 *
 * BizChat docks in reading pane when all of the following conditions are met:
 * - Feature flag 'mon-copilot-bizchat-drawer-readingPane' is enabled
 * - Reading pane is positioned on the right
 * - Reading pane is visible
 * - Compose is not currently shown
 * - BizChat is not already shown in reading pane
 *
 * This selector centralizes the docking logic used across multiple components:
 * - SearchPlusChatEntryPointContainer.tsx (for auto-docking on search)
 * - suggestionSelectedOrchestrator.ts (for docking when selecting copilot suggestions)
 *
 * @param targetWindow - The window object to check BizChat state for
 * @param isComposeShown - Whether compose is currently shown (e.g. from owa-tab-store)
 * @returns true if BizChat should be docked in the reading pane, false otherwise
 */
export function shouldDockBizChatInReadingPane(
    targetWindow: Window,
    isComposeShown: boolean
): boolean {
    const isBizChatShownInReadingPane = shouldShowBizChatInReadingPane(targetWindow);

    return (
        isFeatureEnabled('mon-copilot-bizchat-drawer-readingPane') &&
        isReadingPanePositionRight() &&
        shouldShowReadingPane() &&
        !isComposeShown &&
        !isBizChatShownInReadingPane
    );
}
